import React, { Component } from 'react'
import axios from "axios"

export class ForEndorsementModal extends Component {

    state = {
        onholdMessage: ""
    }

    handleUpdateMultiple = () => {
        for (let i = 0; i < this.props.crfToUpdate.length; i++) {
            axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/inProcess/${this.props.crfToUpdate[i]}`,
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  window.location.reload()
              })
              .catch(error => {
                    
                })
        }
    }


    handleMultipleOnHold = (e) => {
        // e.preventDefault()
        for (let i = 0; i < this.props.crfToUpdate.length; i++) {
            axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/onHold/${this.props.crfToUpdate[i]}`,
                data: {
                  reason:this.state.onholdMessage
                },
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  if(response.data.data.nModified === 1){
                    window.location.reload()
                  }
              })
              .catch(error => {
                    
                })
        }
       
      }

      handleOnHoldMessage = (e) => {
          this.setState({
              onholdMessage: e.target.value
          })
      }
    
     
    render() {  

        let content = ''
      if(this.props.status === 'On Hold'){
        content = <div id="modalContentDashboard">
                        <h3 className="toOnHoldModalHead">On hold</h3>
                        <div className="modalInputForEndorsement">
                            <h5>Message:</h5>
                            <textarea onChange={this.handleOnHoldMessage} type="text" className="onHoldMessageInput" rows="4" cols="50"/>
                        </div>
                        <div className="toOnHoldBtnGroup">
                            <button className="toOnholdBulkBtn" onClick={this.handleMultipleOnHold}>Confirm</button>
                            <button className="toOnholdCloseBulkBtn" onClick={this.props.handleCloseModal}>Cancel</button>
                        </div>
                    </div>
    }else{
        content = <div id="modalContentDashboard">
                    <h3 className="messageHead">Message</h3>
                    <div className="modalInputForEndorsement">
                        <h5 className="toInProcessModalHead">You are about to tag these requests as "IN PROCESS" press IN PROCESS or CANCEL.</h5>
                        
                    </div>
                    <div className="toOnHoldBtnGroup">
                        <button className="toOnholdBulkBtn" onClick={this.handleUpdateMultiple}>Confirm</button>
                        <button className="toOnholdCloseBulkBtn" onClick={this.props.handleCloseModal}>Cancel</button>
                    </div>
                </div>
    }

        return (
            <div id="modalBody" className="modalBody">
                <div className="modalContainer" >
                    <div className="modalbg">
                        {content}
                    </div>
                </div>
            </div>
        )
    }
}

const textRed = {
    color: "red"
}

export default ForEndorsementModal
